import { render, staticRenderFns } from "./LanguagesDesktop.vue?vue&type=template&id=19729009"
import script from "./LanguagesDesktop.vue?vue&type=script&lang=js"
export * from "./LanguagesDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports